import axios from "axios";
import * as ActionType from "./type";

// get avatarFrame
export const getAvatarFrame = (type) => (dispatch) => {
  axios
    .get(`svga/all?type=${type}&limit=1000`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.GET_AVATAR_FRAME_GIF,
          payload: res.data.data,
        });
      }
    })
    .catch((error) => console.log("error", error));
};

// get SVGA only
export const getSvga = () => (dispatch) => {
  axios
    .get(`svga/all?type=svga&limit=1000`)
    .then((res) => {
      if (res.data.status) {
        console.log("svga", res.data.data);
        dispatch({
          type: ActionType.GET_SVGA_GIF,
          payload: res.data.data,
        });
      }
    })
    .catch((error) => console.log("error", error));
};

// Create avatarFrame
export const crateAvatarFrame = (data) => (dispatch) => {
  axios
    .post(`svga/create?type=frame`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CERATE_AVATAR_FRAME_GIF,
          payload: res.data.data,
        });
      }
    })
    .catch((error) => console.log("error", error));
};

export const updateAvatarFrame = (id, data) => (dispatch) => {
  return axios.post(`svga/${id}?type=frame`, data).then((res) => {
    if (res.data.status) {
      dispatch({
        type: ActionType.UPDATE_AVATAR_FRAME_GIF,
        payload: { data: res.data.data, id },
      });
    }
    return res.data;
  });
};

export const deleteAvatarFrame = (id) => (dispatch) => {
  axios
    .delete(`svga/${id}?type=frame`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_AVATAR_FRAME_GIF, payload: id });
      }
    })
    .catch((error) => console.log("error", error));
};
